import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack, StatusPill, Typography } from '@lyearn/ui';
import { LiveRippleLight } from '@/components/Live';
import { EventStatusEnum } from '@/types/schema';

import { TAGS } from './consts';

function StatusLabel({ status }: { status?: EventStatusEnum | null }) {
  const { t } = useTranslation();

  if (!status) {
    return null;
  }

  if (status === EventStatusEnum.Started) {
    return (
      <Stack
        alignItems="center"
        className="h-24 flex-shrink-0 rounded-16 bg-bg-error-light ps-6 pe-10"
        justifyContent="center">
        <LiveRippleLight />
        <Typography className="ms-6" color="text-text-error" variant="label-caps">
          {t('Common:Live')}
        </Typography>
      </Stack>
    );
  }

  // @ts-ignore
  const tag = TAGS[status];

  if (!tag) {
    return null;
  }

  return (
    <StatusPill
      appearance={tag.appearance}
      className="capitalize"
      data-testid="status"
      label={t(tag.label)}
      size="large"
      variant="light"
    />
  );
}

export default React.memo(StatusLabel);
